import {
  Card,
  CardBody,
  CardHeader,
  Button,
  ButtonGroup,
  H3,
} from "@datapay-by-datacom/design-system";
import { useCombinedInvitations } from "../../org/hooks/OrgInvite/useCombinedInvitations";
import { useState } from "react";
import { InvitationItem } from "../../org/types/InvitationItem";
import s from "./OrgInvitationSection.module.css";

export function OrgInvitationSection() {
  const { allInvitations, respondToInvitation, isLoading } =
    useCombinedInvitations();
  const [respondingToId, setRespondingToId] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<{
    invitationId: string;
    message: string;
  } | null>(null);

  const handleAccept = async (item: InvitationItem) => {
    setRespondingToId(item.invitation.invitation_id);
    const success = await respondToInvitation(item, true);
    setRespondingToId(null);
    if (success) {
      setSuccessMessage({
        invitationId: item.invitation.invitation_id,
        message: `Successfully accepted invitation to ${item.invitation.org_id}`,
      });
      // Remove success message after 3 seconds
      setTimeout(() => setSuccessMessage(null), 3000);
    }
  };

  const handleDecline = async (item: InvitationItem) => {
    setRespondingToId(item.invitation.invitation_id);
    const success = await respondToInvitation(item, false);
    setRespondingToId(null);
    if (success) {
      setSuccessMessage({
        invitationId: item.invitation.invitation_id,
        message: `Successfully declined invitation to ${item.invitation.org_id}`,
      });
      // Remove success message after 3 seconds
      setTimeout(() => setSuccessMessage(null), 3000);
    }
  };

  if (isLoading) {
    return (
      <Card>
        <CardBody>
          <p>Loading invitations...</p>
        </CardBody>
      </Card>
    );
  }

  if (allInvitations.length === 0) {
    return (
      <Card>
        <CardBody>
          <p>You have no pending invitations.</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <div className={s.list}>
      {allInvitations.map((item) => (
        <Card key={item.invitation.invitation_id}>
          <CardHeader>
            <div className={s.cardHeader}>
              <H3>
                <strong>Organization:</strong> {item.invitation.org_id}
              </H3>
            </div>
          </CardHeader>
          <CardBody>
            <div className={s.cardContent}>
              <div className={s.cardDetails}>
                <div className={s.detail}>
                  <strong>Category:</strong> {item.invitation.org_category}
                </div>
                <div className={s.detail}>
                  <strong>Role:</strong>{" "}
                  <span
                    className={
                      item.invitation.role === "admin"
                        ? `${s.roleBadge} ${s.roleAdmin}`
                        : s.roleBadge
                    }
                  >
                    {item.invitation.role}
                  </span>
                </div>
                {successMessage?.invitationId ===
                  item.invitation.invitation_id && (
                  <div className={s.successMessage}>
                    {successMessage.message}
                  </div>
                )}
              </div>
              <ButtonGroup>
                <Button
                  variant="primary"
                  onPress={() => handleAccept(item)}
                  isDisabled={respondingToId === item.invitation.invitation_id}
                >
                  {respondingToId === item.invitation.invitation_id
                    ? "Accepting..."
                    : "Accept"}
                </Button>
                <Button
                  variant="secondary"
                  onPress={() => handleDecline(item)}
                  isDisabled={respondingToId === item.invitation.invitation_id}
                >
                  {respondingToId === item.invitation.invitation_id
                    ? "Declining..."
                    : "Decline"}
                </Button>
              </ButtonGroup>
            </div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
}
